import LayoutPage from "./LayoutPage";

export default LayoutPage;
